export const ExtraProductObjectType = {
  Product: "Product",
  ProductCategory: "ProductCategory",
};
